import { render, staticRenderFns } from "./PImage.vue?vue&type=template&id=23729c15&scoped=true"
import script from "./PImage.vue?vue&type=script&lang=js"
export * from "./PImage.vue?vue&type=script&lang=js"
import style0 from "./PImage.vue?vue&type=style&index=0&id=23729c15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23729c15",
  null
  
)

export default component.exports